module.exports = __webpack_public_path__ + "img/006-lawyer.f94f2d5a.png";